import { render, staticRenderFns } from "./Pitanje.vue?vue&type=template&id=42d4224d&scoped=true&"
import script from "./Pitanje.vue?vue&type=script&lang=js&"
export * from "./Pitanje.vue?vue&type=script&lang=js&"
import style0 from "./Pitanje.vue?vue&type=style&index=0&id=42d4224d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d4224d",
  null
  
)

export default component.exports